import { BaseDashboardActionItem, LoadableTypography } from '@uplift/ui-v2';
import React from 'react';
import { DrawOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { ROUTING_CONFIG } from '@uplift/constants';


type PhysicianUnsignedCollaborativeAgreementsProps = {
  stateIds: string[];
};


const PhysicianUnsignedCollaborativeAgreementsContent: React.VFC<PhysicianUnsignedCollaborativeAgreementsProps> = (props) => {
  const history = useHistory();

  return (
    <BaseDashboardActionItem
      title={<Typography><b>{props.stateIds.length}</b> Counter-sign Collaborative Practice Agreement{props.stateIds.length > 1 ? 's' : ''}</Typography>}
      body={(
        <Typography variant="body2" sx={{ mt: -1 }}>
          Your NP has signed - your counter-signature is required to activate the agreement
        </Typography>
      )}
      color="danger"
      icon={<DrawOutlined />}
      action={{
        handleClick: () => {
          history.push(ROUTING_CONFIG.documentsCenter);
        },
        text: 'Review & Sign'
      }}
    />
  );
};


export const PhysicianUnsignedCollaborativeAgreements: React.VFC<PhysicianUnsignedCollaborativeAgreementsProps> = (props) => {
  return (
    <React.Suspense
      fallback={(
        <BaseDashboardActionItem
          title={<LoadableTypography width="400px" />}
          body={<Box sx={{ mt: -1 }}><LoadableTypography variant="body2" width="400px" /></Box>}
          color="danger"
          icon={<DrawOutlined />}
        />
      )}
    >
      <PhysicianUnsignedCollaborativeAgreementsContent stateIds={props.stateIds} />
    </React.Suspense>
  );
};
